import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/examprep')({
  beforeLoad: () => {
    throw redirect({ to: '/exams', replace: true });
  },
})
